export default {
   ASSESSMENT: {
      REMAINING: {
         en: 'Waktu Tersisa Sampai Kuis Dimulai',
         in: 'Time Remaining Until Quiz Start'
      },
      VIEW_QUIZ: {
         en: 'View Quiz',
         in: 'Lihat Kuis'
      },
      START_FOR_QUIZ: {
        en: 'Start Quiz',
        in: 'Mulai Kuis'
      },
      NEXT_FOR_QUIZ: {
        en: 'Continue Quiz',
        in: 'Lanjutkan Kuis'
      },
      QUIT_QUIZ: {
         en: 'Are you sure to get out of here?',
         in: 'Apakah anda yakin untuk keluar dari sini?'
      },
      QUIT_PREVIEW:{
         en: 'Are you sure to get out of quiz preview?',
         in: 'Apakah anda yakin untuk keluar dari preview kuis?'
      },
      QUIZ_OVER: {
         en: 'Quiz time is up!',
         in: 'Waktu mengerjakan Quiz telah Habis !'
      },
      START_QUIZ: {
         en: 'Are you sure to start Quiz?',
         in: 'Apakah anda yakin untuk memulai Quiz?'
      },
      START_QUIZ_NOTE: {
         en: 'Note: after starting the Quiz you have to finish it because the countdown has already started',
         in: 'Note : setelah memulai Quiz maka anda harus menyelesaikannya karena waktu hitung mundur sudah dijalankan'
      },
      WARNING_QUIZ: {
         en: 'You haven not finished answering all the questions, are you sure you want to submit answers?',
         in: 'Anda blm selesai menjawab semua pertanyaan, apakah anda yakin ingin submit jawaban?'
      },
      SUBMIT_QUIZ: {
         en: 'Are you sure you want to submit your answer?',
         in: 'Apakah Anda yakin ingin mengirimkan jawaban anda?'
      },
      BTN_START_QUIZ: {
         en: 'Mulai Quiz',
         in: 'Start Quiz'
      },
      SCORE_TITLE: {
         en: 'Score And Feedback',
         in: 'Skor dan Tanggapan'
      },
      SCORE: {
         en: 'Score',
         in: 'Skor'
      },
      TOTAL_SCORE: {
         en: 'Total Score',
         in: 'Skor Total'
      },
      Comment: {
         en: 'Teacher Comment:',
         in: 'Komentar Guru:'
      },
      STUDENT_NOTE: {
         en: 'Student Note:',
         in: 'Catatan Siswa:'
      },
      ANSWER: {
         en: 'The Answer is:',
         in: 'Jawabannya adalah:'
      },
      START_TIME: {
        en: "Start Time",
        in: "Waktu Mulai"
      },
      END_TIME: {
        en: "End Date",
        in: "Waktu Berakhir"
      },
      TEACHER: {
        en: "Teacher",
        in: "Guru"
      },
      FINISH: {
        en: "Finish",
        in: "Selesai"
      },
      CONFIRMATION_SUBMIT: {
        en: "Are you sure to submit this answer ?",
        in: "Apakah anda yakin ingin menyimpan jawaban ini ?"
      },
      QUIZ_NOT_STARTED: {
        en: "The quiz schedule has not started yet",
        in: "Jadwal kuis belum dimulai"
      },
      ASK_FOR_NEXT_QUESTION: {
        en: "Are you sure you want to proceed to the next question ?",
        in: "Apakah anda yakin ingin melanjutkan ke pertanyaan selanjutnya ?"
      },
      ASK_FOR_NEXT_TO_INFORMATION: {
        en: "Are you sure you want to proceed to the quiz information ?",
        in: "Apakah anda yakin ingin melanjutkan ke informasi kuis ?"
      },
      ASK_FOR_NEXT_TO_FINISH: {
        en: "Are you sure you want to finish this quiz ?",
        in: "Apakah anda yakin ingin menyelesaikan kuis ini ?"
      },
      ASK_FOR_START: {
        en: "Do you want to start this quiz ?",
        in: "Apakah anda ingin memulai kuis ini ?"
      },
      ASK_FOR_QUIT: {
        en: "Do you want to quit this quiz ?",
        in: "Apakah anda ingin keluar dari kuis ini ?"
      },
      LIST_PARTICIPANT: {
        en: "List Participant",
        in: "Daftar Peserta"
      },
      INFORMATION_QUIZ: {
        en: "Quiz Information",
        in: "Informasi Kuis"
      },
      WAITING_QUIZ_NOT_STARTED: {
        en: "Please Wait A Moment, The Quiz Has Not Been Started By The Teacher",
        in: "Mohon Tunggu Sesaat Lagi, Quiz Belum Dimulai Oleh Guru"
      },
      WAITING_FOR_NEXT_QUESTION: {
        en: "Please Wait Until Continued To The Next Question",
        in: "Mohon Tunggu Hingga Lanjut Ke Soal Berikutnya"
      },
   },
   DO_ASSESSMENT: {
      UPLOAD_WORK: {
         en: 'Upload Your Work',
         in: 'Upload Perkejaan Anda'
      },
      YOUR_KUIS: {
         en: 'Your Kuis',
         in: 'Kuis Anda'
      }
   },
   ANSWER_TYPE: {
      TITLE: {
         en: 'Answer Type:',
         in: 'Jenis Jawaban:'
      },
      TEXT: {
         en: 'TEXT',
         in: 'TEXT'
      },
      RICH_TEXT: {
         en: 'Essay',
         in: 'Essay'
      },
      MULTIPLE_CHOICE: {
         en: 'Multiple Choice',
         in: 'Pilihan Ganda'
      },
      MANY_ANSWERS: {
         en: 'Many Answer',
         in: 'Banyak Jawaban'
      },
      TRUE_FALSE: {
         en: 'True/False',
         in: 'Benar/Salah'
      },
      ORDERING: {
         en: 'Ordering',
         in: 'Pengurutan'
      },
      MATCHING: {
         en: 'Matching',
         in: 'Menjodohkan'
      },
      FILL_BLANK: {
         en: 'Fill In The Blank',
         in: 'Isi Bagian Kosong'
      },
      TEMPLATE: {
        en: 'Template',
        in: 'Template'
      },
   },
}
